/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import DialogScrollContainer from '@shared/components/DialogScrollContainer';
import { changeHomeRoom, getRooms } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import { CircularProgress } from '@material-ui/core';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch } from 'react-redux';

const HomeRoomDialog = ({ row, refresh, setRefresh }) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [sending, setSending] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [rows, setRows] = useState([]);
	const [page, setPage] = useState(1);
	const [activeId, setActiveId] = useState(row.home_room.id);

	useEffect(() => {
		let isMounted = true;
		setIsLoading(true);
		getRooms('')
			.then((res) => {
				if (!isMounted) return;
				if (res.data.meta.last_page > res.data.meta.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.meta.current_page + 1);
				setRows(res.data.data);
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			})
			.finally(() => {
				if (!isMounted) return;
				setIsLoading(false);
			});

		return () => {
			isMounted = false;
		};
	}, [dispatch]);

	const handleLoadMore = () => {
		getRooms('', page)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	const handleRoomChange = () => {
		setSending(true);
		const data = {
			student_id: row.id,
			room_id: activeId,
		};
		changeHomeRoom(data)
			.then((res) => {
				setRefresh(refresh + 1);
				dispatch(
					Actions.showMessage({
						message: res.data.message,
						variant: 'success',
					}),
				);
				dispatch(Actions.closeDialog());
				setSending(false);
			})
			.catch((err) => {
				console.log({ ...err });
				setSending(false);
			});
	};

	return (
		<div className="bg-white px-32 min-h-[450px] max-h-[480px] pt-[10px] min-[400px]:min-w-[370px] min-[500px]:min-w-[440px]">
			<div className="flex justify-between py-[10px] px-0 content-center items-center mx-auto font-bold w-[90%]">
				<div>
					<h1 className="text-[20px] font-bold my-[13.4px]"> Choose Homeroom</h1>
				</div>
				<div>
					<i
						className="fas text-[20px]"
						onClick={() => dispatch(Actions.closeDialog())}
						style={{ cursor: 'pointer' }}
					/>
				</div>
			</div>
			<DialogScrollContainer id="scrollable-list">
				{isLoading ? (
					<div className="w-1/12 mx-auto mt-16">
						<CircularProgress size={35} />
					</div>
				) : (
					rows?.map((room, i, arr) => {
						return (
							<div
								key={room.name}
								onClick={() => setActiveId(room.id)}
								style={{
									cursor: 'pointer',
									background: room.id === activeId ? '#F0F9FF' : 'white',
								}}
							>
								<div className="p-16 flex justify-between items-center">
									<div className="w-[310px]">
										<h5 className="text-[14px]">{room.name}</h5>
									</div>
									<div
										className="rounded-full flex justify-center items-center p-4 text-white border-[1px] border-[#4DA0EE] w-[24px] h-[24px]"
										style={{
											background: room.id === activeId ? '#4DA0EE' : 'white',
											// padding: '2px 5px',
										}}
									>
										<i className="fas fa-check" />
									</div>
								</div>
								{i !== arr.length - 1 ? <hr style={{ borderColor: 'lightgray' }} /> : null}
							</div>
						);
					})
				)}
			</DialogScrollContainer>
			<div className="w-full flex justify-center">
				{sending ? (
					<div className="w-1/12 mx-auto mt-24">
						<CircularProgress size={35} />
					</div>
				) : (
					<div className="mt-[25px]">
						<CustomButton height={38} onClick={handleRoomChange} type="button" width={156}>
							Update Homeroom
						</CustomButton>
					</div>
				)}
			</div>
			<InfiniteScroll
				dataLength={rows.length}
				hasMore={hasMore}
				next={handleLoadMore}
				scrollableTarget="scrollable-list"
			/>
		</div>
	);
};

export default HomeRoomDialog;
